"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InferenceErrorCodeRetiredError = exports.InferenceErrorCodeAlreadyExistsError = exports.InferenceErrorCodeNotFoundError = exports.SpecClauseSelfReplacementError = exports.SpecClauseReplacementRetiredError = exports.SpecClauseAlreadyReplacedError = exports.SpecClauseNotRetiredError = exports.SpecClauseShortNameConflictError = exports.SpecClauseSupersededError = exports.SpecClauseRetiredError = exports.SpecClauseVersionConflictError = exports.SpecClauseNotFoundError = void 0;
exports.isSpecClauseNotFoundError = isSpecClauseNotFoundError;
exports.isSpecClauseVersionConflictError = isSpecClauseVersionConflictError;
exports.isSpecClauseRetiredError = isSpecClauseRetiredError;
exports.isSpecClauseSupersededError = isSpecClauseSupersededError;
exports.isSpecClauseShortNameConflictError = isSpecClauseShortNameConflictError;
exports.isSpecClauseNotRetiredError = isSpecClauseNotRetiredError;
exports.isSpecClauseAlreadyReplacedError = isSpecClauseAlreadyReplacedError;
exports.isSpecClauseReplacementRetiredError = isSpecClauseReplacementRetiredError;
exports.isSpecClauseSelfReplacementError = isSpecClauseSelfReplacementError;
exports.isInferenceErrorCodeNotFoundError = isInferenceErrorCodeNotFoundError;
exports.isInferenceErrorCodeAlreadyExistsError = isInferenceErrorCodeAlreadyExistsError;
exports.isInferenceErrorCodeRetiredError = isInferenceErrorCodeRetiredError;
class SpecClauseNotFoundError extends Error {
    constructor(clauseId) {
        super(`Specification clause not found: ${clauseId}`);
        this.name = this.constructor.name;
        this.clauseId = clauseId;
    }
}
exports.SpecClauseNotFoundError = SpecClauseNotFoundError;
function isSpecClauseNotFoundError(error) {
    return error instanceof SpecClauseNotFoundError;
}
class SpecClauseVersionConflictError extends Error {
    constructor(clauseId) {
        super(`Clause ${clauseId} is no longer the current version of its clause. ` +
            `Someone else edited it — reload the clause and try again.`);
        this.name = this.constructor.name;
        this.clauseId = clauseId;
    }
}
exports.SpecClauseVersionConflictError = SpecClauseVersionConflictError;
function isSpecClauseVersionConflictError(error) {
    return error instanceof SpecClauseVersionConflictError;
}
class SpecClauseRetiredError extends Error {
    constructor(clauseId) {
        super(`Clause ${clauseId} is retired and cannot be edited. Reinstate it first, or write a new clause.`);
        this.name = this.constructor.name;
        this.clauseId = clauseId;
    }
}
exports.SpecClauseRetiredError = SpecClauseRetiredError;
function isSpecClauseRetiredError(error) {
    return error instanceof SpecClauseRetiredError;
}
class SpecClauseSupersededError extends Error {
    constructor(clauseId) {
        super(`Clause ${clauseId} was replaced by another clause and cannot be reinstated. ` +
            `Retire the replacement first if this clause should apply again.`);
        this.name = this.constructor.name;
        this.clauseId = clauseId;
    }
}
exports.SpecClauseSupersededError = SpecClauseSupersededError;
function isSpecClauseSupersededError(error) {
    return error instanceof SpecClauseSupersededError;
}
class SpecClauseShortNameConflictError extends Error {
    constructor(args) {
        super(`The name '${args.shortName}' is already used by clause #${args.conflictingClauseNumber} ` +
            `under '${args.propertyKey}'. Choose a different name.`);
        this.name = this.constructor.name;
        this.propertyKey = args.propertyKey;
        this.shortName = args.shortName;
        this.conflictingClauseNumber = args.conflictingClauseNumber;
    }
}
exports.SpecClauseShortNameConflictError = SpecClauseShortNameConflictError;
function isSpecClauseShortNameConflictError(error) {
    return error instanceof SpecClauseShortNameConflictError;
}
class SpecClauseNotRetiredError extends Error {
    constructor(clauseId) {
        super(`Clause ${clauseId} is still active. Supersede it instead of recording a replacement.`);
        this.name = this.constructor.name;
        this.clauseId = clauseId;
    }
}
exports.SpecClauseNotRetiredError = SpecClauseNotRetiredError;
function isSpecClauseNotRetiredError(error) {
    return error instanceof SpecClauseNotRetiredError;
}
class SpecClauseAlreadyReplacedError extends Error {
    constructor(clauseId) {
        super(`Clause ${clauseId} already has a replacement. Reload the clauses to see it.`);
        this.name = this.constructor.name;
        this.clauseId = clauseId;
    }
}
exports.SpecClauseAlreadyReplacedError = SpecClauseAlreadyReplacedError;
function isSpecClauseAlreadyReplacedError(error) {
    return error instanceof SpecClauseAlreadyReplacedError;
}
class SpecClauseReplacementRetiredError extends Error {
    constructor(replacementClauseId) {
        super(`Clause ${replacementClauseId} is retired and cannot replace another clause. Choose an active clause.`);
        this.name = this.constructor.name;
        this.replacementClauseId = replacementClauseId;
    }
}
exports.SpecClauseReplacementRetiredError = SpecClauseReplacementRetiredError;
function isSpecClauseReplacementRetiredError(error) {
    return error instanceof SpecClauseReplacementRetiredError;
}
class SpecClauseSelfReplacementError extends Error {
    constructor(clauseId) {
        super(`Clause ${clauseId} cannot replace itself. Choose a different clause.`);
        this.name = this.constructor.name;
        this.clauseId = clauseId;
    }
}
exports.SpecClauseSelfReplacementError = SpecClauseSelfReplacementError;
function isSpecClauseSelfReplacementError(error) {
    return error instanceof SpecClauseSelfReplacementError;
}
class InferenceErrorCodeNotFoundError extends Error {
    constructor(errorCodeId) {
        super(`Inference error code not found: ${errorCodeId}`);
        this.name = this.constructor.name;
        this.errorCodeId = errorCodeId;
    }
}
exports.InferenceErrorCodeNotFoundError = InferenceErrorCodeNotFoundError;
function isInferenceErrorCodeNotFoundError(error) {
    return error instanceof InferenceErrorCodeNotFoundError;
}
class InferenceErrorCodeAlreadyExistsError extends Error {
    constructor(args) {
        super(`The error code '${args.code}' already exists under '${args.propertyKey}'. ` +
            `Pick a different code, or reinstate the existing one if it was retired.`);
        this.name = this.constructor.name;
        this.propertyKey = args.propertyKey;
        this.code = args.code;
    }
}
exports.InferenceErrorCodeAlreadyExistsError = InferenceErrorCodeAlreadyExistsError;
function isInferenceErrorCodeAlreadyExistsError(error) {
    return error instanceof InferenceErrorCodeAlreadyExistsError;
}
class InferenceErrorCodeRetiredError extends Error {
    constructor(errorCodeId) {
        super(`Error code ${errorCodeId} is retired and cannot be edited. Reinstate it first.`);
        this.name = this.constructor.name;
        this.errorCodeId = errorCodeId;
    }
}
exports.InferenceErrorCodeRetiredError = InferenceErrorCodeRetiredError;
function isInferenceErrorCodeRetiredError(error) {
    return error instanceof InferenceErrorCodeRetiredError;
}
//# sourceMappingURL=package-data-spec.errors.js.map